import { useState } from 'react';
import { LOGIN_URL } from '../lib/auth';
import '../styles/login.css';

/**
 * Pre-auth landing. Entra ID only — no email fallback. No real metrics are
 * shown before authentication (PRD §7 / prototype chat decision).
 */
export function Login() {
  const [redirecting, setRedirecting] = useState(false);

  const signIn = () => {
    setRedirecting(true);
    window.location.assign(LOGIN_URL);
  };

  return (
    <div className="login-shell">
      <div className="login-left">
        <div style={{ position: 'relative', zIndex: 2 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <img
              src="/brand/fortalice-wordmark.svg"
              alt="Fortalice"
              style={{ width: 200, height: 'auto', color: '#ffffff', display: 'block' }}
            />
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: 'rgba(255,255,255,0.75)',
                letterSpacing: '0.18em',
                textTransform: 'uppercase',
              }}
            >
              Cash Forecasting
            </div>
          </div>
        </div>
        <div style={{ position: 'relative', zIndex: 2 }}>
          <div
            style={{
              fontSize: 36,
              fontWeight: 600,
              letterSpacing: '-0.02em',
              lineHeight: 1.15,
              maxWidth: 480,
            }}
          >
            Know your cash position before the month closes.
          </div>
          <div
            style={{
              fontSize: 14,
              color: 'rgba(255,255,255,0.7)',
              marginTop: 18,
              maxWidth: 460,
              lineHeight: 1.55,
            }}
          >
            A 12-month rolling forecast, client-aware receivables, and AI-assisted variance
            attribution &mdash; refreshed daily, secured by Entra ID.
          </div>
        </div>
      </div>
      <div className="login-right">
        <div className="login-card">
          <h2>Sign in</h2>
          <p>
            Authentication is handled by Microsoft Entra ID. Your role (<strong>Editor</strong> or{' '}
            <strong>Viewer</strong>) is set by group membership.
          </p>
          <button className="entra-btn" onClick={signIn} disabled={redirecting}>
            <div className="ms-logo">
              <span className="a" />
              <span className="b" />
              <span className="c" />
              <span className="d" />
            </div>
            {redirecting ? 'Redirecting…' : 'Continue with Microsoft'}
          </button>
          <div className="login-meta">
            <span>fortalice.onmicrosoft.com</span>
            <span>SSO · MFA enforced</span>
          </div>
        </div>
      </div>
    </div>
  );
}
